<template>
	<div class="box">
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<Form @submit="onSubmit" class="vertical_self_form" v-if="form.qusList && form.qusList.length">
			<Field
				v-for="(item, index) in form.qusList"
				:key="index"
				v-model="item.answer"
				:name="'qusList.' + index + '.answer'"
				:label="item.name"
				:placeholder="$t('base.question.placeholder')"
				:show-error-message="false"
				:scroll-to-error="true"
			/>
			<!-- :rules="[
          { required: true, message: '回答错误', validator: handlePromise },
        ]" -->
			<div style="margin-top: 30px">
				<Button round block type="info" native-type="submit">{{ $t("base.btn.next_step") }}</Button>
			</div>
		</Form>
		<div v-else class="hint">{{ $t("base.question.not_set") }}</div>
	</div>
</template>

<script>
import { Form, Field, Button, NavBar } from "vant";
import { commonAPI } from "@/apis";
import { toast } from "@/utils/toast";

export default {
	name: "Problem",
	components: { Form, Field, Button, NavBar },
	data() {
		return {
			type: "",
			form: { qusList: [] },
			objInfo: {},
		};
	},
	created() {
		this.type = this.$route.query.type;
		if (this.type == "forget") {
			this.objInfo = JSON.parse(localStorage.getItem("FORGET_INFO")) || {};
			console.log(this.objInfo);
		} else if (this.type == "activate") {
			this.objInfo = JSON.parse(localStorage.getItem("ACTIVATE_INFO")) || {};
		} else {
			this.objInfo = JSON.parse(sessionStorage.getItem("user")) || {};
		}
		console.log(this.objInfo);
		// 获取问题验证
		this.getSelfInfo();
	},
	methods: {
		// 获取自己的密保问题
		async getSelfInfo() {
			const { code, data } = await commonAPI.getAction(`/users/getPwdQuestionByUser/${this.objInfo.username}`);
			if (code == 0) {
				let arr = data || [];
				arr.forEach((el) => {
					this.form.qusList.push({
						name: el.question,
						question: el.id,
						answer: "",
					});
				});
				console.log(this.form.qusList);
			}
		},
		// 验证密保问题
		async onSubmit(values) {
			console.log("submit", this.form);
			let params = {
				userName: this.objInfo.username,
				questionVos: this.form.qusList,
			};
			// 验证密保问题
			const { code, message } = await commonAPI.postAction("/password/reset/checkSecurityQuestion", params);
			if (code == 0) {
				toast(message);
				this.$router.push({
					path: "/mnewPassword",
					query: { type: this.type }, //表示类型是账号激活或者是忘记密码
				});
			} else {
				toast(message);
				return;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";

.box {
	height: 100vh;
	.hint {
		text-align: center;
		line-height: 70px;
	}
}
</style>
